export const getPresentationRestoreKey = (series) => (
  series?.studyInstanceUID && series?.seriesInstanceUID
    ? `${series.studyInstanceUID}:${series.seriesInstanceUID}`
    : ''
);

export const createPresentationRestoreCoordinator = ({
  getCurrentKey,
  apply,
  finish = () => {},
  onError = () => {},
}) => {
  let generation = 0;

  const isCurrent = (token, key) => (
    token === generation && key === String(getCurrentKey?.() || '')
  );

  return {
    async restore({ key, load }) {
      const restoreKey = String(key || '');
      const token = ++generation;
      try {
        const result = await load();
        if (!isCurrent(token, restoreKey)) return false;
        apply(result, restoreKey);
        return true;
      } catch (error) {
        if (isCurrent(token, restoreKey)) onError(error, restoreKey);
        return false;
      } finally {
        if (isCurrent(token, restoreKey)) {
          finish(restoreKey, () => isCurrent(token, restoreKey));
        }
      }
    },
    invalidate() {
      generation += 1;
    },
  };
};
